import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import RouteFallback from 'src/components/RouteFallback';
import RouteWithSubRoutes from 'src/utils/route';

import { BlankConfig } from '../../routes';

class BlankLayout extends React.Component {
  public render() {
    return (
      <Switch>
        {BlankConfig.map((route: any, index: number) => {
          return <RouteWithSubRoutes key={index} {...route} />;
        })}
        <Route component={RouteFallback} />
      </Switch>
    );
  }
}

export default BlankLayout;



// WEBPACK FOOTER //
// ./src/layouts/BlankLayout/index.tsx